import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { closeNewModel } from "../../store/slices/modalSlice";
import { useEffect, useState } from "react";
import axios from "axios";
import { setTrue } from "../../store/slices/IdSlice";import React from "react";

const DotLottieReact = React.lazy(() =>
  import("@lottiefiles/dotlottie-react").then(module => ({
    default: module.DotLottieReact,
  }))
);

import { TooltipLink } from "../TooltipLink/TooltipLink";

import { A11y, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/react";

const baseUrl = import.meta.env.VITE_API_URL;

interface PackageDetails {
  PackageName: string;
  options: string; // If options should be an array of numbers, change this to: number[]
  PackageId: number;
  serviceid: number;
  priceId: number;
}

interface ServiceDetails {
  title: string;
  description: string;
  sub2ServiceName: string;
  PriceAmount: number;
  subCat: string;
  serviceName: string;
  img: string;
  outsideDescription: string;
}

const NewModel = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [packageDetails, setPackageDetails] = useState<PackageDetails>({
    PackageName: "",
    options: "",
    PackageId: 1, // Provide a default number
    serviceid: 1, // Provide a default number
    priceId: 1, // Provide a default number
  });
  const [services, setservices] = useState<ServiceDetails[]>([]);
  const [totalPrice, setTotalPrice] = useState<number>();
  const [selectedOption, setSelectedOption] = useState<string[]>([
    "yes",
    "company",
    "New Visa",
    "category 2",
    "Skilled",
    "outside",
  ]);

  const openNewModel = useSelector(
    (state: { modal: { newModel: boolean } }) => state.modal.newModel
  );

  const handleCloseNewModal = () => {
    dispatch(closeNewModel());
  };

  const clearSessionState = () => {
    sessionStorage.removeItem("PriceRecordId");
    sessionStorage.removeItem("serviceid");
    sessionStorage.removeItem("text");
    sessionStorage.removeItem("optionSelected");
  };

  const apiCall = async (
    ServiceId: number,
    PriceRecordIds: any,
    optionSelectedd: any
  ) => {
    const payload = {
      optionSelected: optionSelectedd,
      PriceRecordIds: PriceRecordIds,
      ServiceId: ServiceId,
    };
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/cart/handlePackage`,
        payload
      );

      if (response.data.packagefound === true) {
        setTotalPrice(response.data.packageData.totalPrice);
        setPackageDetails(response.data.packageData.packageDetails);
        setservices(response.data.packageData.services2);
      }
    } catch (error) {
      console.error();
    } finally {
      stopLoadingAfterDelay();
      clearSessionState();
    }
  };

  useEffect(() => {
   import("../chooseYesNoModel/newFlowmodal.css");
      import("../model/updateModel.css");
    const ServiceId = getdatafromsessionstorage("serviceid");
    const optionSelected = getItemFromSessionStorage("optionSelected");
    setSelectedOption(optionSelected);

    apiCall(ServiceId, null, optionSelected);
  }, []);

  const addDataToDataBase = async (
    PriceRecordId: number | null,
    ServiceId: number,
    op: string,
    applicantid: number
  ) => {
    const UUID = localStorage.getItem("uuid");
    try {
      const postData = {
        ServiceId,
        Quantity: op === "plus" ? 1 : -1,
        PriceRecordId,
        UUID,
        applicantid,
      };

      const response = await axios.post(
        `${baseUrl}/api/cart/addCart`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response;
      if (data) {
        dispatch(setTrue());
        sessionStorage.removeItem("PriceRecordId");
        sessionStorage.removeItem("serviceid");
        sessionStorage.removeItem("text");
        dispatch(closeNewModel());
      }
    } catch (error) {
      console.error("postData Error fetching user profile data:", error);
    }
  };

  const getdatafromsessionstorage = (key: string): any => {
    const storedData = sessionStorage.getItem(key);
    if (storedData) {
      return storedData ? JSON.parse(storedData) : null;
    }
  };

  const getItemFromSessionStorage = (key: string): any[] => {
    const storedData = sessionStorage.getItem(key);
    if (storedData) {
      return storedData ? JSON.parse(storedData) : [];
    } // Return parsed data or an empty array if not found
    return [];
  };

  const stopLoadingAfterDelay = () => {
    setTimeout(() => {
      setLoading(false);
    }, 2000); // 3 seconds delay
  };

  return (
    <>
      <Modal
        show={openNewModel} // Fixed variable name
        onHide={handleCloseNewModal}
        className=""
        scrollable
        backdrop="static"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="modal-dialog-scrollable">
          {loading ? (
            <div className="container d-flex flex-column align-items-center justify-content-center gap-4">
              <div className="p-10 m-10">
                <DotLottieReact
                  src="https://lottie.host/e06766cd-c697-4ee0-a6f2-4ad3cfaf5ec1/52PAvyt8wm.lottie"
                  loop
                  autoplay
                />
              </div>
            </div>
          ) : (
            <div className="selected-visa-content">
              <div className="modal-service-card ">
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="list-card-main shadow-none border-0 d-flex align-items-start align-items-md-center mb-0  bg-3 gap-3 py-2  justify-content-between">
                      <div>
                        <div className="image-container">
                          {/* Static Image */}
                          <img
                            loading="lazy"
                            src="https://goodhand.b-cdn.net/Assets/Footer_pages/GreenVisa/Green%20Visa/Green%20visa%20For%20self-employment.jpg"
                            alt="Static Service Image"
                            className="img-fluid d-block mx-auto"
                          />
                          {/* Static Add/Minus buttons and counter */}
                          <div className="d-flex flex-column align-items-center justify-content-center">
                            <div className="d-flex align-items-center btn-add position-absolute gap-1 gap-md-2">
                              <button className="bt-mi p-0">-</button>
                              <span className="counter-numbers down">1</span>
                              <button className="bt-plu p-0">+</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-8">
                        <div id="inside_69"></div>
                        <div className="sub-hd1" id="69">
                          <p className="mb-2">{packageDetails.PackageName}</p>
                        </div>
                        <div className="d-flex align-items-center gap-2 mb-2">
                          {/* <div className="d-flex">
                              <div
                                style={{
                                  width: "14px",
                                  height: "14px",
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: "5px",
                                }}
                              >
                                <svg
                                  width="14"
                                  height="17"
                                  viewBox="0 0 14 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.5 1.5V4.61111C8.5 4.81739 8.58194 5.01522 8.72781 5.16108C8.87367 5.30694 9.0715 5.38889 9.27778 5.38889H12.3889"
                                    stroke="#6E42E5"
                                    strokeWidth="1.55556"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M10.8333 15.5H3.05556C2.643 15.5 2.24733 15.3361 1.95561 15.0444C1.66389 14.7527 1.5 14.357 1.5 13.9444V3.05556C1.5 2.643 1.66389 2.24733 1.95561 1.95561C2.24733 1.66389 2.643 1.5 3.05556 1.5H8.5L12.3889 5.38889V13.9444C12.3889 14.357 12.225 14.7527 11.9333 15.0444C11.6416 15.3361 11.2459 15.5 10.8333 15.5Z"
                                    stroke="#6E42E5"
                                    strokeWidth="1.55556"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M4.61133 10.8333L6.16688 12.3889L9.27799 9.27777"
                                    stroke="#6E42E5"
                                    strokeWidth="1.55556"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                              <span className="font-12 ff-medium ">10</span>
                            </div> */}
                          <TooltipLink
                            title="e.g Passport"
                            Id={packageDetails.PackageName.toString()}
                            styleName="9999999999999"
                          >
                            <div className="d-flex align-items-center gap-1 bg-beige include-main cursor-pointer">
                              <div
                                style={{
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: "5px",
                                }}
                              >
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/IconsNewServiceDetail/includes.svg"
                                  className="img-fluid"
                                  alt=""
                                  style={{
                                    width: "14px",
                                    height: "14px",
                                  }}
                                />
                              </div>
                              <span className="font-12 ff-medium ">
                                Includes
                              </span>
                            </div>
                          </TooltipLink>
                        </div>

                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <p className="d-flex align-items-center gap-1 mb-0">
                            <span className="in-badge px-0">
                              <span className="ff-bold font-13">
                                <span className="ff-currency ff-medium  font-16">
                                  
                                </span>
                                {totalPrice?.toFixed(2)}
                              </span>
                            </span>
                          </p>
                        </div>

                        <div>
                          <a
                            href="/services/packages"
                            className="mb-1 font-12 text-primary ff-semibold"
                          >
                            Explore More Packages
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="py-2  text-center">
                  <p className="font-12 ff-semibold text-black mb-0">
                    Selected Categories
                  </p>
                  <div className="choosed-cat-wrap">
                    <Swiper
                      modules={[Pagination, A11y]}
                      spaceBetween={10}
                      slidesPerView={3.2}
                      breakpoints={{
                        320: { slidesPerView: 3.2, spaceBetween: 20 },
                        768: { slidesPerView: 3.2, spaceBetween: 20 },
                      }}
                    >
                      {selectedOption.slice(1).map((category, index) => (
                        <SwiperSlide key={index}>
                          <div className="choosed-cat rounded py-1 px-2">
                            <p className="mb-0 font-12 ff-medium text-black">
                              {category}
                            </p>
                            <div>
                              <img
                                src="https://goodhand.b-cdn.net/Assets/Flow/edit-round.svg"
                                alt={category}
                              />
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>

                {/* <AddonModal /> */}

                <div className="container">
                  <p className="text-center font-16 font-sm-14 text-black ff-semibold mb-1">
                    Services Offered in This Packages
                  </p>
                  {/* {serviceStepsData.line && (
                      <p
                        className="font-12 text-grey ff-normal text-center"
                        dangerouslySetInnerHTML={{
                          __html: serviceStepsData.line,
                        }}
                      />
                    )} */}
                  <div className="row">
                    <div className="timeline-container">
                      {services.map((step, index) => (
                        <div
                          key={`steps_${index}`}
                          className="timeline-card layout-border"
                        >
                          <div className="timeline-step"></div>
                          <div
                            className={`timeline-title done font-12 ff-semibold mb-2`}
                          >
                            <div>
                              <svg
                                width="100%"
                                height="12"
                                viewBox="0 0 7 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.27045 1.00428C5.7922 1.30553 6.22623 1.73782 6.52956 2.25837C6.8329 2.77891 6.99502 3.36965 6.99989 3.9721C7.00475 4.57456 6.85219 5.16784 6.55731 5.69321C6.26242 6.21859 5.83543 6.65784 5.31862 6.96748C4.8018 7.27712 4.21308 7.44642 3.61073 7.45861C3.00837 7.4708 2.41328 7.32546 1.88436 7.03698C1.35544 6.74851 0.911032 6.32689 0.595129 5.81388C0.279227 5.30087 0.102786 4.71424 0.0832726 4.11209L0.081543 4.00001L0.0832726 3.88792C0.102646 3.29051 0.276489 2.7083 0.587856 2.19807C0.899222 1.68784 1.33748 1.26699 1.85992 0.976562C2.38235 0.686132 2.97112 0.536029 3.56884 0.540886C4.16655 0.545743 4.75281 0.705395 5.27045 1.00428ZM4.82317 3.06358C4.7636 3.00402 4.68435 2.96824 4.60028 2.96295C4.51621 2.95767 4.4331 2.98324 4.36654 3.03487L4.33402 3.06358L3.19489 4.20237L2.7476 3.75543L2.71509 3.72672C2.64852 3.67513 2.56543 3.64959 2.48138 3.65489C2.39733 3.66019 2.3181 3.69598 2.25855 3.75553C2.199 3.81507 2.16322 3.8943 2.15792 3.97835C2.15262 4.0624 2.17816 4.1455 2.22975 4.21206L2.25846 4.24458L2.95032 4.93643L2.98283 4.96514C3.0435 5.01221 3.1181 5.03776 3.19489 5.03776C3.27167 5.03776 3.34627 5.01221 3.40694 4.96514L3.43946 4.93643L4.82317 3.55272L4.85188 3.5202C4.90351 3.45365 4.92908 3.37054 4.92379 3.28647C4.91851 3.2024 4.88273 3.12315 4.82317 3.06358Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                            <div
                              className="font-10 ff-bold"
                              dangerouslySetInnerHTML={{
                                __html: step.sub2ServiceName ?? "",
                              }}
                            ></div>
                          </div>
                          <p
                            className="font-14 ff-bold text-black mb-1"
                            dangerouslySetInnerHTML={{
                              __html: step.title ?? "",
                            }}
                          />
                          <p
                            className="font-12 ff-medium text-grey mb-1"
                            dangerouslySetInnerHTML={{
                              __html: step.description ?? "",
                            }}
                          />
                          {/* <div className="w-100 p-0 m-0 service-completion p-2 position-relative">
                              <p className="item-count rounded-0 text-noti font-11 mb-0 ff-semibold d-flex align-items-center gap-2">
                                <span>
                                  {" "}
                                  <svg
                                    width="13"
                                    height="12"
                                    viewBox="0 0 13 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M6.49993 0C7.06429 0 7.59023 0.275972 7.91229 0.736909L7.97434 0.83146L12.7693 8.83759C12.915 9.08997 12.9943 9.3752 12.9997 9.66658C13.0051 9.95796 12.9365 10.2459 12.8003 10.5036C12.6641 10.7612 12.4647 10.98 12.2208 11.1396C11.977 11.2992 11.6966 11.3942 11.406 11.4159L11.2907 11.4206H1.70264C1.41172 11.4173 1.12637 11.3404 0.873229 11.197C0.620088 11.0536 0.407407 10.8484 0.255039 10.6005C0.102671 10.3527 0.0155832 10.0703 0.00190455 9.77967C-0.0117741 9.48905 0.0484024 9.19971 0.176817 8.93864L0.235321 8.82932L5.02789 0.829096C5.18134 0.576061 5.3974 0.36684 5.65525 0.221616C5.91309 0.0763913 6.20401 6.51029e-05 6.49993 0ZM6.49993 5.51352H5.90899L5.83985 5.51766C5.69622 5.53474 5.56384 5.60391 5.4678 5.71206C5.37175 5.82021 5.3187 5.95982 5.3187 6.10447C5.3187 6.24911 5.37175 6.38873 5.4678 6.49687C5.56384 6.60502 5.69622 6.67419 5.83985 6.69128L5.90899 6.69541V8.46825L5.91312 8.53739C5.92868 8.6693 5.98822 8.79212 6.08214 8.88604C6.17606 8.97996 6.29888 9.0395 6.43079 9.05506L6.49993 9.05919H7.09088L7.16002 9.05506C7.29193 9.0395 7.41475 8.97996 7.50867 8.88604C7.60259 8.79212 7.66213 8.6693 7.67769 8.53739L7.68182 8.46825L7.67769 8.39911C7.66356 8.27854 7.61265 8.16525 7.53187 8.07464C7.45109 7.98403 7.34436 7.92049 7.2262 7.89267L7.16002 7.88085L7.09088 7.8773V6.10447L7.08674 6.03533C7.07119 5.90342 7.01164 5.78059 6.91772 5.68667C6.8238 5.59275 6.70098 5.53321 6.56907 5.51766L6.49993 5.51352ZM6.50584 3.74068L6.43079 3.74482C6.28716 3.76191 6.15479 3.83107 6.05874 3.93922C5.96269 4.04737 5.90965 4.18699 5.90965 4.33163C5.90965 4.47627 5.96269 4.61589 6.05874 4.72404C6.15479 4.83219 6.28716 4.90135 6.43079 4.91844L6.49993 4.92258L6.57498 4.91844C6.71861 4.90135 6.85099 4.83219 6.94703 4.72404C7.04308 4.61589 7.09613 4.47627 7.09613 4.33163C7.09613 4.18699 7.04308 4.04737 6.94703 3.93922C6.85099 3.83107 6.71861 3.76191 6.57498 3.74482L6.50584 3.74068Z"
                                      fill="#CF770C"
                                    ></path>
                                  </svg>
                                </span>
                                <span>Have you completed this service?</span>
                                <span className="info-icon">
                                  <div>
                                    <span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="-49 141 512 512"
                                        width="16"
                                        height="16"
                                        aria-hidden="true"
                                      >
                                        <path
                                          fill="#6e42e5"
                                          d="M207 653c-68.38 0-132.667-26.629-181.02-74.98C-22.371 529.667-49 465.38-49 397s26.629-132.667 74.98-181.02C74.333 167.629 138.62 141 207 141s132.667 26.629 181.02 74.98C436.371 264.333 463 328.62 463 397s-26.629 132.667-74.98 181.02C339.667 626.371 275.38 653 207 653m0-462C93.411 191 1 283.411 1 397s92.411 206 206 206 206-92.411 206-206-92.411-206-206-206"
                                        ></path>
                                        <path
                                          fill="#6e42e5"
                                          d="M217 543c-13.807 0-25-11.193-25-25V391h-25c-13.807 0-25-11.193-25-25s11.193-25 25-25h50c13.807 0 25 11.193 25 25v152c0 13.807-11.193 25-25 25m-10-232c-16.542 0-30-13.458-30-30s13.458-30 30-30 30 13.458 30 30-13.458 30-30 30"
                                        ></path>
                                      </svg>
                                    </span>
                                    <span className="font-11 text-primary ff-medium">
                                      Need Help?
                                    </span>
                                  </div>
                                  <span className="info-box">
                                    <div className="p-3 bg-3 rounded mb-3">
                                      <p className="font-12 ff-bold text-black">
                                        Get Help
                                      </p>
                                      <div className="d-flex align-items-center gap-3">
                                        <div className="d-flex align-items-center gap-2 cart-call">
                                          <img
                                            src="https://goodhand.b-cdn.net/Assets/cart/phone-icon.svg"
                                            alt=""
                                          />
                                          <p className="mb-0 ff-medium font-9 text-primary">
                                            Call
                                          </p>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 cart-whatsap">
                                          <img
                                            src="https://goodhand.b-cdn.net/Assets/cart/whatsap-cart.svg"
                                            alt=""
                                          />
                                          <p className="mb-0 ff-medium font-9">
                                            WhatsApp
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                </span>
                              </p>

                              <div className="radio-group d-flex align-items-center gap-3 mt-2">
                                <label className="custom-radio">
                                  <input
                                    type="radio"
                                    name="serviceCompleted"
                                    value="yes"
                                  />
                                  <span className="radio-btn"></span> Yes
                                </label>
                                <label className="custom-radio">
                                  <input
                                    type="radio"
                                    name="serviceCompleted"
                                    value="no"
                                  />
                                  <span className="radio-btn"></span> No
                                </label>
                              </div>
                            </div> */}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        {!loading && (
          <Modal.Footer>
            <button
              className="done-button btn btn-primary mt-2 float-right flex-grow-1"
              onClick={() =>
                addDataToDataBase(
                  packageDetails?.priceId,
                  packageDetails?.serviceid,
                  "plus",
                  1
                )
              }
            >
              Continue
            </button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default NewModel;
